<template>
  <el-tiptap
    v-model="modelContent"
    :extensions="extensions"
    :charCounterCount="false"
    class="mt-4 custom-border-tiptap"
    style="max-height: 600px"
  />
</template>

<script>
import {
  Doc,
  Text,
  Paragraph,
  Heading,
  Bold,
  Underline,
  Italic,
  Strike,
  ListItem,
  BulletList,
  OrderedList,
  TextAlign,
  Indent,
  FontType,
  FontSize,
  LineHeight,
  TextColor,
  TextHighlight,
  HardBreak,
  TrailingNode,
  Image,
  Link,
  Table,
  TableHeader,
  TableRow,
  TableCell,
  History,
} from 'element-tiptap';

export default {
  name: "WarrantyAdditionEditor",

  props: {
    content: {
      type: String,
      default: '',
    }
  },

  data () {
    return {
      extensions: []
    };
  },

  created() {
    this.extensions = [
      new Doc(),
      new Text(),
      new Paragraph(),
      new Heading({ level: 5 }),
      new Bold({ bubble: true }),
      new Underline(),
      new Italic(),
      new Strike(),
      new ListItem(),
      new BulletList(),
      new OrderedList(),
      new TextAlign({
        alignments: ['left', 'center', 'right', 'justify'],
      }),
      new Indent({
        minIndent: 0,
        maxIndent: 10,
        bubble: true,
      }),
      new FontType({ bubble: true }),
      new FontSize({ bubble: true }),
      new LineHeight({
        lineHeights: ['75%','80%', '100%', '150%', '200%']
      }),
      new TextColor({ bubble: true }),
      new TextHighlight(),
      new HardBreak(),
      new TrailingNode(),
      new Image(),
      new Link(),
      new Table({
        resizable: true
      }),
      new TableHeader(),
      new TableRow(),
      new TableCell(),
      new History(),
    ];
  },

  computed: {
    modelContent: {
      get() {
        return this.content;
      },
      set(value) {
        this.$emit('update:addition', value)
      }
    }
  },
}
</script>
